export default "__VITE_ASSET__be407aeb__"